import React, {
    Dispatch,
    ReactElement,
    ReactNode,
    SetStateAction,
} from 'react'

export enum DropPosition {
    BOTTOM_RIGHT = 'origin-bottom-right bottom-14 right-0',
    TOP_LEFT = 'origin-top-left left-0',
    TOP_RIGHT = 'origin-top-right right-0',
}

export enum StaffAvailability {
    NO_AVAILABILITY = 'NO_AVAILABILITY',
    BUSY = 'BUSY',
    AVAILABLE = 'AVAILABLE',
}

export enum MembershipFilters {
    ALL = 'ALL',
    ACTIVE = 'ACTIVE',
    INACTIVE = 'INACTIVE',
    RETRYING = 'RETRYING',
}

export enum MembershipStatus {
    ACTIVE = 'ACTIVE',
    EXPIRED = 'EXPIRED',
    RENEWAL_FAILED_MAXED_OUT = 'RENEWAL_FAILED_MAXED_OUT',
    RENEWAL_FAILED_RETRYING = 'RENEWAL_FAILED_RETRYING',
    CANCELLED = 'CANCELLED',
}

export type SelectorItemProps = {
    label?: ReactElement
    updateGroupSelection?(selection: number[]): void
    is_expanded?: boolean
    onClick?: (expanded: boolean) => void
    value?: string
    selection?: number[]
    input_component?: ReactElement
    options?: {
        label: string
        value: string
    }[]
}

export type SelectorProps = {
    className?: string
    dropboxClassname?: string
    downButtonClassName?: string
    position?: DropPosition
    items: SelectorItemProps[]
    selected?: Record<string, string>
    close_on_select?: boolean
    is_opened?: boolean
    handle_click?: boolean
    is_search_enabled?: boolean
    label?: ReactElement
    style?: Record<string, string>
    setInputValue?: React.Dispatch<SetStateAction<string>>
}

//TODO: remove unused props/cleanup
export type ClientSelectorProps = {
    className?: string
    dropboxClassname?: string
    downButtonClassName?: string
    position?: DropPosition
    items: SelectorItemProps[]
    selected?: Record<string, string>
    close_on_select?: boolean
    is_opened?: boolean
    handle_click?: boolean
    is_search_enabled?: boolean
    is_membership_filter_enabled?: boolean
    is_appointment_filter_enabled?: boolean
    is_loading?: boolean
    label?: ReactElement
    style?: Record<string, string>
    setInputValue?: React.Dispatch<SetStateAction<string>>
    is_filtered?: boolean
    setIsFiltered?: (isFiletered: boolean) => any
    membership_filter?: MembershipFilters
    setMembershipFilter?: (filter: MembershipFilters) => any
}
